import React from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import KycDocument, { DropzoneMeta } from '@/pages/settings/verify/kyc-sections/KycDocument';
import KycDescription from '@/pages/settings/verify/kyc-sections/KycDescription';
import { selectKycSourceOfFunds } from '@/store/selectors/kycSelectors';
import { KycType } from '@lucky7ventures/bff-types';

const KycSourceOfFunds = ({ maxFiles = 1 }: { maxFiles?: number }) => {
  const sofDocument = useSelector(selectKycSourceOfFunds);
  const intl = useIntl();

  if (!sofDocument) {
    return null;
  }

  const dropzoneMeta: DropzoneMeta = {
    id: KycType.SourceOfFunds.toString(),
    minFiles: 1, // At least one file is needed for SOF
    maxFiles,
    errorMessageTranslationKey: 'settings.verify.upload.error.imagesAndPdfOnly.text',
  };

  return (
    <KycDocument
      type={KycType.SourceOfFunds}
      status={sofDocument.status}
      acceptedFileTypes={['image/png', 'image/jpeg', 'application/pdf']}
      title={intl.formatMessage({ id: 'verify.SOF.title' })}
      description={<KycDescription kycType={KycType.SourceOfFunds} />}
      dropzonesMeta={[dropzoneMeta]}
      validationErrorMessage={intl.formatMessage({
        id: 'settings.verify.submit.imagesAndPdfOnly.error',
      })}
      key={KycType.SourceOfFunds}
    />
  );
};

export default KycSourceOfFunds;
